// extracted by mini-css-extract-plugin
module.exports = {"formBox":"formBox--nY42u","formBoxInput":"formBoxInput--l9H++","formBoxButton":"formBoxButton--jQoTR","alertBox":"alertBox--DY+iw"};